import "./js/one_tap_cali";
import { XF } from "./js/XF";
import { onetapCanShow } from "./one_tap_canShow";

if (onetapCanShow()) {
  const elHeaderBanner = document.querySelector<HTMLElement>("#header-banner");
  const elHeader = document.querySelector<HTMLElement>("header.js-mainHeader");
  if (!elHeaderBanner || !elHeader)
    throw new Error("could not find header elements");

  const elIframe = document.createElement("iframe");
  elIframe.id = "google-one-tap-iframe";
  elIframe.className = "sign-up__google";
  elIframe.title = "Google One Tap login";
  elIframe.scrolling = "no";
  elIframe.allow = "identity-credentials-get";
  // @ts-expect-error copied from legacy
  elIframe.allowtransparency = "true";
  // @ts-expect-error copied from legacy
  elIframe.frameborder = "0";
  // @ts-expect-error copied from legacy
  elIframe.seamless = "seamless";
  elIframe.width = "1";
  elIframe.height = "1";

  const primisMobileSlider =
    (window as { primisMobileSlider?: boolean }).primisMobileSlider || false;

  if (primisMobileSlider) {
    document.addEventListener("DOMContentLoaded", () => {
      setTimeout(() => {
        elIframe.src = "/login/onetap";
      }, 90000);
    });
  } else {
    elIframe.src = "/login/onetap";
  }
  elHeader.insertAdjacentElement("afterend", elIframe);

  window.addEventListener(
    "message",
    (event) => {
      if (event.origin !== window.location.origin) {
        return;
      }

      if (event.data === "googleOneTapError") {
        XF.alert(XF.phrase("oops_we_ran_into_some_problems"));
      }
    },
    false
  );

  const adjustIframeVerticalPosition = () => {
    if (window.innerWidth > 650) {
      const headerBannerHeight = elHeaderBanner.offsetHeight;
      const { scrollY } = window;
      if (scrollY < headerBannerHeight - elHeader.offsetHeight) {
        elIframe.style.position = "absolute";
        elIframe.style.top = `${elHeader.offsetHeight + elHeader.offsetTop}px`;
      } else {
        elIframe.style.position = "fixed";
        elIframe.style.top = `${elHeader.offsetHeight}px`;
      }

      elIframe.style.width = "500px";
      elIframe.style.right = "20px";
      elIframe.style.left = "auto";
    }
  };

  window.addEventListener("load", adjustIframeVerticalPosition);
  window.addEventListener("scroll", adjustIframeVerticalPosition, {
    passive: true,
  });
}
